// extracted by mini-css-extract-plugin
export default {"app":"app_app__yWwQC","main":"app_main__KjooE","pageTransition":"app_pageTransition__9Y2RA","fadeIn":"app_fadeIn__B-VOu"};